import React from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import theme from './themes/theme';
import './common/i18n';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import IsLogin from './router/IsLogin';
import Payment from './pages/CheckoutForm';
import Return from './pages/CheckoutReturn';
import { LoadingProvider } from "./components/Context/LoadingContext";
import WechatPayment from './pages/WechatPayment';
import {ContentProvider} from "./components/Context/ContentContext";
import ScrollToTopButton from "./components/rewriteComponent/ScrollToTopButton";
import { useTranslation } from 'react-i18next';

// 自适应单位: vw, vh, vmin, vmax, svw, svh, lvw, lvh, dvw, dvh, pvw, pvh, wv, wh, wmin, wmax, sw, sh, lw, lh, dw, dh, pw, ph

const AppContent = () => {
    const { t } = useTranslation();

    const Login = React.lazy(() => import('./pages/Login'));
    const Register = React.lazy(() => import('./pages/Register'));
    const Profile = React.lazy(() => import('./pages/Profile'));
    const Homepage = React.lazy(() => import('./pages/Homepage'));
    const ContentList = React.lazy(() => import('./pages/ContentList'));
    const Comprehension = React.lazy(() => import('./pages/Comprehension'));
    const SubjectiveListing = React.lazy(() => import('./pages/SubjectiveListing'));
    const SubjectiveDetailPage = React.lazy(() => import('./pages/SubjectiveDetailPage'));
    const Subscription = React.lazy(() => import('./pages/Subscription'));
    const CheckoutResult = React.lazy(() => import('./pages/CheckoutResult'));
    const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard'));
    const location = useLocation();

    if (location.pathname === '/AdminDashboard') {
        return (
            <React.Suspense fallback={<div>{t('common.loading')}</div>}>
                <Routes>
                    <Route path={"/AdminDashboard"} element={<AdminDashboard />} />
                </Routes>
            </React.Suspense>
        );
    }

    return (
        <Box
            minHeight="100vh"
            display="flex"
            flexDirection="column"
        >
            <Box>
                {/*header height: 56px*/}
                <Header />
            </Box>
            {/*<Box paddingTop={`80px`}>*/}
            <Box flex="1">
                <Routes>
                    <Route path={"/Login"}
                        element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Login /></React.Suspense>} />
                    <Route path={"/Register"}
                        element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Register /></React.Suspense>} />
                    <Route path={"/Subjective"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <SubjectiveListing /></React.Suspense>} />
                    <Route path={"/SubjectiveDetail"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <SubjectiveDetailPage /></React.Suspense>} />
                    <Route path={"/"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <Homepage /></React.Suspense>} />
                    <Route path={"/ContentList"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <ContentList /></React.Suspense>} />
                    <Route path={"/Return"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <Return />
                           </React.Suspense>} />
                    <Route path={"/ReturnResult"}
                           element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <CheckoutResult />
                           </React.Suspense>} />

                    <Route path={"/Profile"}
                        element={<IsLogin><React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Profile /></React.Suspense></IsLogin>} />
                    <Route path={"/Comprehension"}
                        element={<IsLogin><React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Comprehension /></React.Suspense></IsLogin>} />
                    <Route path={"/Subscription"}
                        element={<React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Subscription /></React.Suspense>} />
                    <Route path={"/Payment"}
                        element={<IsLogin><React.Suspense fallback={<div>{t('common.loading')}</div>}>
                            <Payment /></React.Suspense></IsLogin>} />
                    <Route path={"/WechatPayment"}
                           element={<IsLogin><React.Suspense fallback={<div>{t('common.loading')}</div>}>
                               <WechatPayment /></React.Suspense></IsLogin>} />
                </Routes>
            </Box>
            <Footer />
            <ScrollToTopButton />
        </Box>
    );
};

const App = () => {
    return (
        <ChakraProvider theme={theme}>
            <LoadingProvider>
                <ContentProvider>
                    <BrowserRouter>
                        <AppContent />
                    </BrowserRouter>
                </ContentProvider>
            </LoadingProvider>
        </ChakraProvider>
    );
};

export default App;
